export const MASK_SOURCE_CHAR = '*';

export const MASK_SUBSTITUTION_CHAR = '●';
